import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import StockChart from "../../charts/StockChart";
import { modernFintechPalette } from "../../charts/nivo/utils";
import { selectMetricTimeSeriesData, selectTimeSeriesDataByPaths } from "../../store/slices/timeseries.slice";
import { Spin, Typography } from "antd";
import Placeholder from "../../components/Placeholder";


// Utility function to format the series data flexibly
const formatSeries = (data, dataField) => {
    return data.map((item) => {
        const row = [item.timestamp, item[dataField]];
        if (item.hasOwnProperty('snapshot')) {
            row.push(item.snapshot);
        }
        return row;
    });
};

// Generalized chart data formatting
const formatChartData = (timeseriesData, seriesConfig, colorMapping, labelMapping, yMinorGrid) => {
    const plotData = timeseriesData.map((item, index) => {
        const { timeseriesId, data } = item;
        const { dataField, yScale = 'linear', format = 'linear', thickness = 2 } = seriesConfig[timeseriesId] || {};
        const seriesRows = formatSeries(data, dataField);
        return {
            name: labelMapping ? labelMapping[timeseriesId] : timeseriesId,
            data: seriesRows,
            type: 'line',
            stroke: colorMapping?.[timeseriesId] || modernFintechPalette[index],
            yScale,
            format,
            thickness,
            hasSnapshot: seriesRows[0].length === 3,
            callbackOnSnapshot: item?.callbackOnSnapshot
        };
    });

    return [{
        plot: 0,
        data: plotData,
        yScale: seriesConfig.globalYScale || '',
        format: seriesConfig.globalFormat || '',
        legend: { postfix: seriesConfig.legendPostfix || '', precision: 2 },
        yMinorGrid
    }];
};


const GeneralStockChart = ({
  dataPaths,
  seriesConfig = {},
  colorMapping,
  labelMapping,
  initialSeries,
  customSnapshotCallback,
  ref,
  stockChartProps,
  height = 600,
  heightOffset = 50,
  yMinorGrid = false
}) => {
  const { loading, data: timeSeriesData, error } = useSelector(state => {
    const result = selectTimeSeriesDataByPaths(state, dataPaths);
    return result;
  });

  console.log(timeSeriesData);

  const mergedData = useMemo(() =>
    [...(initialSeries || []), ...(timeSeriesData || [])],
    [initialSeries, timeSeriesData]
  );

  const chartData = useMemo(() => {
    if (!mergedData.length) return null;
    return formatChartData(
      mergedData,
      seriesConfig,
      colorMapping,
      labelMapping,
      yMinorGrid
    );
  }, [mergedData, seriesConfig, colorMapping, labelMapping, yMinorGrid]);

  console.log(chartData);
  if (loading) {
    return <Spin><Placeholder text={'Loading Metrics'}/></Spin>;
  }

  if (error) {
    return <Typography.Text type="danger">{error}</Typography.Text>;
  }

  if (!chartData || chartData[0].data.length === 0) {
    return <Placeholder text={'No data available for the selected metrics'} />;
  }

  return (
    <div style={{ height, width: '100%' }}>
      <StockChart
        height={height - heightOffset}
        dataSeries={chartData}
        customSnapshotCallback={customSnapshotCallback}
        ref={ref}
        {...stockChartProps}
      />
    </div>
  );
};

export default GeneralStockChart;